import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Synopsis`}</h3>
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/hook.js */
    }
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm hook add <pkg> <url> <secret> [--type=<type>]
npm hook ls [pkg]
npm hook rm <id>
npm hook update <id> <url> <secret>
`}</code></pre>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/commands/hook.js */
    }
    {
      /* AUTOGENERATED USAGE DESCRIPTIONS END */
    }
    <p>{`Note: This command is unaware of workspaces.`}</p>
    <h3>{`Description`}</h3>
    <p>{`Allows you to manage `}<a parentName="p" {...{
        "href": "https://blog.npmjs.org/post/145260155635/introducing-hooks-get-notifications-of-npm"
      }}>{`npm
hooks`}</a>{`,
including adding, removing, listing, and updating.`}</p>
    <p>{`Hooks allow you to configure URL endpoints that will be notified whenever a
change happens to any of the supported entity types. Three different types
of entities can be watched by hooks: packages, owners, and scopes.`}</p>
    <p>{`To create a package hook, simply reference the package name.`}</p>
    <p>{`To create an owner hook, prefix the owner name with `}<inlineCode parentName="p">{`~`}</inlineCode>{` (as in,
`}<inlineCode parentName="p">{`~youruser`}</inlineCode>{`).`}</p>
    <p>{`To create a scope hook, prefix the scope name with `}<inlineCode parentName="p">{`@`}</inlineCode>{` (as in,
`}<inlineCode parentName="p">{`@yourscope`}</inlineCode>{`).`}</p>
    <p>{`The hook `}<inlineCode parentName="p">{`id`}</inlineCode>{` used by `}<inlineCode parentName="p">{`update`}</inlineCode>{` and `}<inlineCode parentName="p">{`rm`}</inlineCode>{` are the IDs listed in `}<inlineCode parentName="p">{`npm hook ls`}</inlineCode>{`
for that particular hook.`}</p>
    <p>{`The shared secret will be sent along to the URL endpoint so you can verify
the request came from your own configured hook.`}</p>
    <h3>{`Example`}</h3>
    <p>{`Add a hook to watch a package for changes:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook add lodash https://example.com/ my-shared-secret
`}</code></pre>
    <p>{`Add a hook to watch packages belonging to the user `}<inlineCode parentName="p">{`substack`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook add ~substack https://example.com/ my-shared-secret
`}</code></pre>
    <p>{`Add a hook to watch packages in the scope `}<inlineCode parentName="p">{`@npm`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook add @npm https://example.com/ my-shared-secret
`}</code></pre>
    <p>{`List all your active hooks:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook ls
`}</code></pre>
    <p>{`List your active hooks for the `}<inlineCode parentName="p">{`lodash`}</inlineCode>{` package:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook ls lodash
`}</code></pre>
    <p>{`Update an existing hook's url:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook update id-deadbeef https://my-new-website.here/
`}</code></pre>
    <p>{`Remove a hook:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`$ npm hook rm id-deadbeef
`}</code></pre>
    <h3>{`Configuration`}</h3>
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS START */
    }
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`registry`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: "`}<a parentName="li" {...{
          "href": "https://registry.npmjs.org/%22"
        }}>{`https://registry.npmjs.org/"`}</a></li>
      <li parentName="ul">{`Type: URL`}</li>
    </ul>
    <p>{`The base URL of the npm registry.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    <h4><inlineCode parentName="h4">{`otp`}</inlineCode></h4>
    <ul>
      <li parentName="ul">{`Default: null`}</li>
      <li parentName="ul">{`Type: null or String`}</li>
    </ul>
    <p>{`This is a one-time password from a two-factor authenticator. It's needed
when publishing or changing package permissions with `}<inlineCode parentName="p">{`npm access`}</inlineCode>{`.`}</p>
    <p>{`If not set, and a registry response fails with a challenge for a one-time
password, npm will prompt on the command line for one.`}</p>
    {
      /* automatically generated, do not edit manually */
    }
    {
      /* see lib/utils/config/definitions.js */
    }
    {
      /* AUTOGENERATED CONFIG DESCRIPTIONS END */
    }
    <h3>{`See Also`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://blog.npmjs.org/post/145260155635/introducing-hooks-get-notifications-of-npm"
        }}>{`"Introducing Hooks" blog post`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      